import { ADMIN_CONTEXT, ROLEPLAY_CONTEXT,BASE_CONTEXT_V2_DOCTORS } from "./api-context";

export const DOCTORS = {
    LOAD_DOCTOR_PROFILES:(bu:string)=>`${ROLEPLAY_CONTEXT}doctor_profile_list/${bu}`,

    CREATE:`${BASE_CONTEXT_V2_DOCTORS}doctors/create`,
    UPDATE: (doctor_id:string)=>`${BASE_CONTEXT_V2_DOCTORS}doctors/update/${doctor_id}`,
    DELETE: (doctor_id:string)=>`${BASE_CONTEXT_V2_DOCTORS}doctors/delete/${doctor_id}`,
    LIST: `${BASE_CONTEXT_V2_DOCTORS}doctors/list`,
    BY_ID: (doctor_id:string)=>`${BASE_CONTEXT_V2_DOCTORS}doctors/${doctor_id}`,
}